// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2482":"b70bed7d14980ced","2888":"c1bc5bc0b2758f0c"}[chunkId] + ".css";
};